export const environment = {
  production: false,
  cognito: {
    userPoolId: 'eu-central-1_pfhCqavut',
    userPoolClientId: '4kp6tk4vm2a3bb8q0gjcnt8578',

    socialLogin: {
      domain: 'cuju-test.auth.eu-central-1.amazoncognito.com',
      redirectSignIn: ['https://aguai-stg.peneiras.cuju.pro'],
      redirectSignOut: ['https://aguai-stg.peneiras.cuju.pro'],
    }
  },
  urls: {
    profile: 'https://core-test.cuju.io/profile/v1/user',
    competition: 'https://core-test.cuju.io/competition/v1/participation'
  },
  competitionId: '54a3f79b-d0c6-4ad5-b7ae-48f8f9146c25',
};